import { useState } from 'react';

export const useEditLocation = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleOnClick = () => {
    setIsOpen(true);
  };

  return {
    isOpen,
    handleClose,
    handleOnClick,
  };
};
